import { OrganizationEmployeeDto } from "../app/model/api/types/dto";

export class OrganizationEmployeeViewModel {
  id?: string | null;
  firstName: string | null;
  mi?: string | null;
  lastName: string | null;
  emailAddress: string | null;
  personnelNumber: string | null;
  workPersonnelArea?: string | null;
  divisionName?: string | null;
  supervisorName?: string | null;
  organization?: string | null;
  domainLanId?: string | null;
  statusId?: Array<string> | null;
  typeId?: Array<string> | null;
  organizationUnitName?: string | null;
  stepUpEnrollmentDate?: string | null;
  leadershipEnrollmentDate?: string | null;
  name?: string | null;
  isActive?: boolean | null;

  constructor(
    id: string | null,
    firstName: string | null,
    lastName: string | null,
    emailAddress: string | null,
    personnelNumber: string | null,
    workPersonnelArea?: string | null,
    divisionName?: string | null,
    supervisorName?: string | null,
    domainLanId?: string | null,
    statusId?: Array<string> | null,
    typeId?: Array<string> | null,
    organizationUnitName?: string | null,
    organization?: string | null,
    mi?: string | null,
    stepUpEnrollmentDate?: string | null,
    leadershipEnrollmentDate?: string | null,
    isActive?: boolean | null
  ) {
    this.id = id;
    this.organization = organization;
    this.firstName = firstName;
    this.mi = mi;
    this.lastName = lastName;
    this.emailAddress = emailAddress;
    this.personnelNumber = personnelNumber;
    this.workPersonnelArea = workPersonnelArea;
    this.divisionName = divisionName;
    this.supervisorName = supervisorName;
    this.domainLanId = domainLanId;
    this.statusId = statusId;
    this.typeId = typeId;
    this.organizationUnitName = organizationUnitName;
    this.stepUpEnrollmentDate = stepUpEnrollmentDate;
    this.leadershipEnrollmentDate = leadershipEnrollmentDate;
    this.isActive = isActive;
  }

  toDto(): OrganizationEmployeeDto {
    return {
      id: this.id,
      firstName: this.firstName,
      mi: this.mi && this.mi.trim() ? this.mi : null,
      lastName: this.lastName,
      emailAddress: this.emailAddress,
      personnelNumber:
        this.personnelNumber && this.personnelNumber.trim()
          ? this.personnelNumber
          : null,
      workPersonnelArea:
        this.workPersonnelArea && this.workPersonnelArea.trim()
          ? this.workPersonnelArea
          : null,
      divisionName:
        this.divisionName && this.divisionName.trim()
          ? this.divisionName
          : null,
      supervisorName:
        this.supervisorName && this.supervisorName.trim()
          ? this.supervisorName
          : null,
      domainLanId:
        this.domainLanId && this.domainLanId.trim() ? this.domainLanId : null,
      statusId:
        this.statusId !== null &&
        this.statusId !== undefined &&
        this.statusId?.length > 0
          ? this.statusId[0]
          : null,
      typeId:
        this.typeId !== null &&
        this.typeId !== undefined &&
        this.typeId?.length > 0
          ? this.typeId[0]
          : null,
      organizationUnitName:
        this.organizationUnitName && this.organizationUnitName.trim()
          ? this.organizationUnitName
          : null,
      stepUpEnrollmentDate:
        this.stepUpEnrollmentDate === "" ? null : this.stepUpEnrollmentDate,
      leadershipEnrollmentDate:
        this.leadershipEnrollmentDate === ""
          ? null
          : this.leadershipEnrollmentDate,
      isActive: this.isActive,
    };
  }

  mapFromDto(dto: OrganizationEmployeeDto): void {
    this.id = dto.id;
    this.organization = dto.organization;
    this.isActive = dto.isActive || true;
    this.firstName = dto.firstName;
    this.mi = dto.mi;
    this.lastName = dto.lastName;
    this.emailAddress = dto.emailAddress;
    this.personnelNumber = dto.personnelNumber;
    this.workPersonnelArea = dto.workPersonnelArea;
    this.divisionName = dto.divisionName;
    this.supervisorName = dto.supervisorName;
    this.domainLanId = dto.domainLanId;
    dto.statusId !== null && dto.statusId !== undefined
      ? this.statusId?.push(dto.statusId)
      : (this.statusId = null);
    dto.typeId !== null && dto.typeId !== undefined
      ? this.typeId?.push(dto.typeId)
      : (this.typeId = null);
    this.organizationUnitName = dto.organizationUnitName;
    this.stepUpEnrollmentDate = dto.stepUpEnrollmentDate;
    this.leadershipEnrollmentDate = dto.leadershipEnrollmentDate;
    this.name = `${dto?.lastName}, ${dto?.firstName}`;
  }
}
